import React from 'react'

function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container-custom py-6 flex items-center justify-between">
        <p className="text-sm text-gray-600">© {new Date().getFullYear()} Dkard</p>
        <div className="flex items-center gap-4">
          <a href="/privacy" className="text-sm text-gray-600 hover:text-gray-800">Privacidad</a>
          <a href="/terms" className="text-sm text-gray-600 hover:text-gray-800">Términos</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
